export const enum ProfilePageName {
    Profile = 'profile',
    SiteProfile = 'siteProfile',
    ScheduleSettings = 'scheduleSettings',
    Prices = 'prices',
    Price = 'price',
    Notifications = 'notifications',
    SubscriptionUserPrice = 'subscriptionUserPrice',
}
